import React from 'react'
import './style.scss'

import CF7InformationLanding from '../../../../Form/CF7/InformationLanding'

function CustomBlock({ fields: field }) {

	return (
        <>
            <h2>{field}</h2>
            <CF7InformationLanding />
        </>
	)
}

export default CustomBlock